import React from "react";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";

const LogosContainer = styled.div`
  display: flex;
  height: 100%;
  box-sizing: border-box;

  & a:not(:last-child) {
    margin-right: 30px;

    @media (max-width: 768px) {
      margin-right: 15px;
    }
  }
`;

const LogosLink = styled.a`
  &:nth-child(1),
  &:nth-child(3) {
    align-items: center;
    display: flex;
  }

  &:nth-child(2) {
    height: 80%;

    & svg {
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    & svg {
      height: 50px;
    }
  }

  @media (max-width: 568px) {
    &:nth-child(3) {
      display: none;
    }
  }
`;

export default () => {
  return (
    <LogosContainer>
      <LogosLink
        href="https://nekrasovka.ru"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon fill="#EDEEE9" icon="logoText" width={157} height={57} />
      </LogosLink>
      <LogosLink
        href="https://bibliogorod.ru/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon fill="rgba(237, 238, 233, 0.2)" icon="logoBiblio" width={34} />
      </LogosLink>
      <LogosLink
        href="https://www.mos.ru/kultura/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon
          fill="rgba(237, 238, 233, 0.2)"
          icon="logoDepMos"
          width={150}
          height={57}
        />
      </LogosLink>
    </LogosContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/LogosContainer/index.js